<template>
    <div>
        <h4>Select a status to apply</h4>
        <div class="status-selection">
            <md-field>
                <label>Status</label>
                <md-select v-model="statusModel" md-no-validate>
                    <md-option v-for="status in statusOptions" :key="status" :value="status">
                        {{ status }}
                    </md-option>
                </md-select>
            </md-field>
        </div>
    </div>
</template>

<script>
import { STATUS_CONSTANTS } from '@/utils/constants';

export default {
    name: 'ChangeStatus',
    props: {
        selectedStatus: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            statusOptions: STATUS_CONSTANTS
        };
    },
    computed: {
        statusModel: {
            get() {
                return this.selectedStatus;
            },
            set(value) {
                this.$emit('status-selected', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.status-selection {
    margin-top: 20px;
    max-width: 300px;
}

/* Fix for dropdown text visibility */
::v-deep .md-select {
    .md-select-value {
        color: #000 !important;
    }

    .md-menu-content {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}

::v-deep .md-input {
    -webkit-text-fill-color: #000 !important;
}

::v-deep .md-menu-content {
    .md-list {
        .md-list-item-content {
            color: #000 !important;
        }
    }
}
</style>
